var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAllContestsicon = function SvgAllContestsicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1.5em",
    height: "1.5em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.2 20.4a1.2 1.2 0 0 0 1.737 1.073l4.8-2.4A1.2 1.2 0 0 0 20.4 18v-6.917a1.2 1.2 0 0 0-1.736-1.073l-4.8 2.4a1.2 1.2 0 0 0-.664 1.073zm5.053-12.869a1.2 1.2 0 0 0 0-2.145l-5.716-2.859a1.2 1.2 0 0 0-1.073 0L5.747 5.386a1.2 1.2 0 0 0 0 2.145l5.717 2.859a1.2 1.2 0 0 0 1.072 0zm-12.916 2.48A1.2 1.2 0 0 0 3.6 11.082V18a1.2 1.2 0 0 0 .664 1.073l4.8 2.4A1.2 1.2 0 0 0 10.8 20.4v-6.917a1.2 1.2 0 0 0-.664-1.073z"
  })));
};
export default SvgAllContestsicon;